module.exports = __webpack_public_path__ + "img/industry_4.42350194.png";